module.exports = __webpack_public_path__ + "static/img/retail_img_1_cn.aa24073.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/retail_img_1_cn.png
// module id = 7Ff+
// module chunks = 0